module.exports = __webpack_public_path__ + "static/ignite.bf558505.png";